<template>
  <span class="tag" :class="[status]">
    <slot>{{ text }}</slot>
  </span>
</template>

<script lang="ts" src="./TagElement.ts"></script>

<style scoped lang="scss" src="./TagElement.scss"></style>
